import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Skills from "@/components/Skills";
import Experience from "@/components/Experience";
import Projects from "@/components/Projects";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ScrollProgress from "@/components/ScrollProgress";
import Loader from "@/components/Loader";

const Portfolio = () => (
  <div data-testid="portfolio-page" className="bg-[#050505] text-white">
    <Loader />
    <ScrollProgress />
    <Header />
    <main>
      <Hero />
      <About />
      <Skills />
      <Experience />
      <Projects />
      <Contact />
    </main>
    <Footer />
    <Toaster
      theme="dark"
      position="bottom-right"
      toastOptions={{
        style: {
          background: "#0a0a0a",
          color: "#ffffff",
          border: "1px solid rgba(255,255,255,0.15)",
          borderRadius: 0,
          fontFamily: "JetBrains Mono, monospace",
          fontSize: "12px",
          letterSpacing: "0.02em",
        },
      }}
    />
  </div>
);

function App() {
  return (
    <div className="App overflow-x-hidden w-full">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Portfolio />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
